import { FETCH_ALL, CREATE, UPDATE, DELETE, SEARCH, START_LOADING, END_LOADING, FETCH_POST, COMMENT, FETCH_MORE, FETCH_SIMILAR, START_LOADING_SEARCH, END_LOADING_SEARCH} from '../constants/actionTypes';



const reducer = (state={isLoading:true, posts: []}, action) => {

    let newState = {};

    switch(action.type){

        //loading state cases
        case START_LOADING:

            return {
                ...state,
                isLoading: true
            }


        case END_LOADING:

            return {
                ...state,
                isLoading: false
            }

        //loading state cases
        case START_LOADING_SEARCH:

            return {
                ...state,
                isLoadingSearch: true
            }


        case END_LOADING_SEARCH:

            return {
                ...state,
                isLoadingSearch: false
            }


        //post cases
        case SEARCH: 

            return {
                ...state,
                searchResults: action.payload
            }; 
        
        case FETCH_SIMILAR: 

            console.log('FETCH SIMILAR in reducer, payload: ', action.payload);

            return {
                ...state,
                post: { ...action.payload.post, similarPosts: action.payload.similarPosts}
            }

        case FETCH_ALL:
            return {
                ...state,
                posts: action.payload.data,
                currentPage: action.payload.currentPage,
                numberOfPages: action.payload.numberOfPages
            }; 

        case FETCH_MORE:
            return {
                ...state,
                posts: [...state.posts, ...action.payload.data],
                currentPage: action.payload.currentPage,
                numberOfPages: action.payload.numberOfPages
            }; 

        case FETCH_POST:
            console.log('FETCH_POST in reducer, payload: ', action.payload);
            return {
                ...state,
                post: action.payload.data
            };

        case CREATE:
            newState = {
                ...state,
                posts: [
                    action.payload,
                    ...state.posts,
                ]
            };

            return newState;
        
        case UPDATE:

            newState = {
                ...state,
                posts: state.posts.map((post) => post._id === action.payload._id ? action.payload : post)
            };

            return newState;

        case DELETE:

            newState = {
                ...state,
                posts: state.posts.filter((post) => post._id !== action.payload)
            }

            return newState;

        case COMMENT: 

            console.log('Action payload: ', action.payload);

            newState = {
                ...state,
                posts: state.posts.map((post) => {

                    //if post id matches that in payload return payload post instead
                    if(post._id === action.payload._id){

                        return action.payload.post;

                    }

                    //otherwise return normal post already in state
                    return post; 
                })
            }

            return newState; 

        default:
            return state;
    }
}

export default reducer;